import { HttpRequestOptions } from '@common/clients/http/http.client.interface';

type Request<Type> = {
  options?: HttpRequestOptions<Type>;
  url: string;
};

export type CommonErrorType<Type = unknown> = {
  code?: string;
  message: string;
  messageTranslationKey?: string;
  request?: Request<Type>;
  statusCode?: number;
};

export class CommonError<Type = unknown> extends Error implements CommonErrorType<Type> {
  code?: string;

  message: string;

  messageTranslationKey?: string;

  request?: Request<Type>;

  statusCode?: number;

  constructor(error: CommonErrorType<Type>) {
    super(error.message);
    this.code = error.code;
    this.message = error.message;
    this.request = error.request;
    this.statusCode = error.statusCode;
    this.messageTranslationKey = error.messageTranslationKey;
  }

  translate(translator: (key: string) => string): CommonError<Type> {
    const message =
      (this.messageTranslationKey && translator(this.messageTranslationKey)) || this.message;
    this.message = message === this.messageTranslationKey ? this.message : message;

    return this;
  }
}
